import React, { useState, useEffect } from 'react';
import Layout from '../../core/Layout';
import { isAuthenticated} from '../../auth';
import { recieverUpdateOrder, senderUpdateOrder, getOrder, getUserInfo } from '../apiUser';
import { Link, useParams, withRouter } from 'react-router-dom';
import OrderFormFinished from './OrderFormFinished';
import AddShipping from '../AddShipping';
import { Modal, Button } from 'react-bootstrap';
import { sendNotification } from '../../core/sendNotification';

var shippo = require('shippo')('shippo_test_78a3a7e8883b86a4f9d562017f313dfd9b24fb71'); //TODO put in env

const FillOrder = ({history}) => { //CLEAN UP UNUSED STUFF
    const [order, setOrder] = useState({});
    const [addresses, setAddresses] = useState([]); 
    const [recieverDidFill, setRecieverDidFill] = useState(false); // (I no longer use these) XXX
    const [senderDidFill, setSenderDidFill] = useState(false)      //
    const [price, setPrice] = useState('');
    const [priceLoading, setPriceLoading] = useState(false);
    const [priceError, setPriceError] = useState('');

    const [values, setValues] = useState({
        length: '',
        width: '',
        height: '',
        weight: '',
        error: '',
        success: false,
        formData: '',
    });
    
    const { length, width, height, weight,  error, formData } = values;

    const { user: {_id}, token } = isAuthenticated();
    const { orderId } = useParams();
    const [isReciever, setIsReciever] = useState(false);
    
    //Success modal
    const [successModalIsOpen, setSuccessModalIsOpen] = useState(false);
    const handleOpen = () => setSuccessModalIsOpen(true);
    const handleClose = () => setSuccessModalIsOpen(false);
    const goToOrders = () => {
        window.location = '/user/orders';
    };
    const successModal = () => (
        <Modal
        show={successModalIsOpen}
        onHide={handleClose}
        size='sm'
        >
            <Modal.Header>
                <Modal.Title>
                    Success
                </Modal.Title>
            </Modal.Header>
                <Modal.Body>
                    You will not be charged till both parties have filled out information.
                </Modal.Body>
            <Modal.Footer>
                <button onClick={goToOrders}> Go to orders</button>
                <button onCLick={handleClose}> Edit Info </button>
            </Modal.Footer>
        </Modal>
     );

    const handleUpdateAddresses = () => {
        init();
    };
    
    //form functions
    const handleChange = name => event => {
        const value = event.target.value;;
        formData.set(name, value);
        setValues({...values, [name]: value});
    };
    
    const showPriceLoading = () => priceLoading && (
        <div className='alert alert-success'>
            <h2> Loading costs... </h2>
        </div>
    );

    const clickSubmit = event => {
        event.preventDefault();
        formData.append('orderId', orderId);
        setValues({...values, error: ''});
        if (isReciever) {
            recieverUpdateOrder(orderId, _id, token, formData)
                .then(data => {
                    if (data.error) {
                        setValues({...values, error: data.error, success: false})
                    }
                    else {
                        handleOpen();
                        setValues({...values, error: '', shipping: '', success: true});
                        getUserInfo(_id).then(data => {
                            const { name } = data;
                            sendNotification('order','',`${name} has filled out their order form`,
                                'Click to fill order form', ``,
                                '/user/orders',_id, order.sender);
                        });
                        //history.push(`/user/orders`);
                    }
                });
        }
        else {
            console.log('SENDER');
            //is sender
            senderUpdateOrder(orderId, _id, token, formData)
                .then(data => {
                    if (data.error) {
                        setValues({...values, error: data.error, success: false})
                    }
                    else {
                        handleOpen()
                        setValues({...values, error: '', shipping: '', success: true});
                        getUserInfo(_id).then(data => {
                            const { name } = data;
                            sendNotification('order','',`${name} has filled out their order form`,
                                'Click to fill order form', ``,
                                '/user/orders',_id, order.reciever);
                        });


                        //history.push(`/user/orders`);
                    }

                });
        }
        //window.location.reload(); 
    };


    const init = () => {
        getOrder(_id, orderId, token).then(data => {
            setOrder(data);
        });
        //check if reciever and sender already filled out form 
        if (isReciever) {
            order.recieverDidFill ? setRecieverDidFill(true) : setRecieverDidFill(false);
        } 
        else {
            order.senderDidFill ? setSenderDidFill(true) : setSenderDidFill(false);
        }

        setValues({...values, shipping: '', error: '', formData: new FormData()});
        getUserInfo(_id)
            .then(data => {
                console.log(data.shipping_addresses);
                setAddresses(data.shipping_addresses);
            });
        
    };
    
    useEffect(() => {
        getOrder(_id, orderId, token)
            .then(data => {
                data.reciever === _id ? setIsReciever(true) : setIsReciever(false);
            });

        init();
    },[]);
    
    const showPriceError = () => {
        if (priceError) {
            return (
                <div className='alert alert-danger'>
                    {priceError}
                </div>
            );
        }
    };
    const showError = () => (
        <div className='alert alert-danger' style={{display: error ? '' : 'none'}}>
            {error}
        </div>
    );
    

    const chooseShippingAddr = () => (
        <form className='mb-3' onSubmit={clickSubmit}>
            <h3> Item Box Info </h3>
            <div className='form-group p-1'>
                <label className='text-muted'>Length </label>
                <input
                    onChange={handleChange('length')}
                    type='number'
                    className='form-control'
                    value={length}
                />
            </div>

            <div className='form-group p-1'>
                <label className='text-muted'>Width</label>
                <input
                    onChange={handleChange('width')}
                    type='number'
                    className='form-control'
                    value={width}
                />
            </div>

            <div className='form-group p-1'>
                <label className='text-muted'>Height</label>
                <input
                    onChange={handleChange('height')}
                    type='number'
                    className='form-control'
                    value={height}
                />
            </div>

            <div className='form-group p-1'>
                <label className='text-muted'>Weight</label>
                <input
                    onChange={handleChange('weight')}
                    type='number'
                    className='form-control'
                    value={weight}
                />
            </div>


               <br/>
                <button type='submit' className='btn btn-primary' onClick={clickSubmit}> Next </button>
        </form>
    );

    return (
        <Layout title='Order Form' >
            {successModal()}
            {showError()}
            {chooseShippingAddr()}
        </Layout>
    );
};

export default FillOrder;
